
import PaymentOrder from './PaymentOrder.vue';

export default {
  name: 'PaymentOrderMobile',
  components: { PaymentOrder },
};
